import React, { FC } from "react";
import styled from "styled-components";
import { ThemeProps } from "../styles/theme";
import { renderInlineMarkup } from "../markup/renderInlineMarkup";
import {
    DataCell,
    HeaderCell,
    TableGrid,
    TableWrapper,
} from "../markup/referenceViewer/referenceGrid";

export interface DisplayRow {
    cells: string[];
    revealedColumns: number;
}

const Placeholder = styled.span<ThemeProps>`
    color: ${p => p.theme.secondaryText};
    letter-spacing: 2px;
`;

interface TrainingTableGridProps {
    header: string[] | null;
    colCount: number;
    rows: DisplayRow[];
}

export const TrainingTableGrid: FC<TrainingTableGridProps> = ({ header, colCount, rows }) => (
    <TableWrapper>
        <TableGrid $cols={colCount}>
            {header !== null && header.map((cell, colIdx) => (
                <HeaderCell key={`h-${colIdx}`} $isFirstRow={true} $isLastCol={colIdx === colCount - 1}>
                    {renderInlineMarkup(cell)}
                </HeaderCell>
            ))}
            {rows.map((row, rowIdx) => {
                const isFirstRow = rowIdx === 0 && header === null;
                return Array.from({ length: colCount }).map((_, colIdx) => (
                    <DataCell
                        key={`${rowIdx}-${colIdx}`}
                        $isFirstRow={isFirstRow}
                        $isLastCol={colIdx === colCount - 1}
                        $highlight={false}
                    >
                        {colIdx < row.revealedColumns
                            ? renderInlineMarkup(row.cells[colIdx])
                            : <Placeholder>···</Placeholder>}
                    </DataCell>
                ));
            })}
        </TableGrid>
    </TableWrapper>
);
